<template>

  <div class="is-relative">
      <b-loading :is-full-page="false" :active="previewBusy" :can-cancel="false"></b-loading>
      <iframe src="" ref="iframe" style="height: 75vh; width: 100%;"></iframe>
  </div>

</template>

<script>

import debounce from 'lodash/debounce';
import { ApiUtil as $api } from '@/utils/api.util.js';

export default {

  props: {
    profile: { type: String, required: true },
    template: { type: String, required: true }
  },

  data() {
    return {
      pdfBusy: false,
      previewBusy: false
    };
  },

  computed: {
    conversionPayload() {
      return {
        preview: true,
        html: this.template,
        profile: this.profile // e.g. order vs invoice etc.
      }
    }
  },

  watch: {
    template: function(newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.onTemplateChanged();
      }
    }
  },

  methods: {
    onDownloadPdf() {
      const vm = this;
      const payload = Object.assign({}, this.conversionPayload, { preview: false });
      this.pdfBusy = true;
      return $api.postDownload('templates/html-to-pdf', payload, 'document.pdf')
      .catch(err => {
        vm.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred while attempting to download your file.'
        });
      })
      .finally(() => {
        this.pdfBusy = false;
      });
    },

    onTemplateChanged: debounce(function() {
      this.updateRemotePreview();
    }, 1000),

    dangerouslySetPreviewHtml(html) {
      // WARNING: The html you pass to this function MUST be pre-sanitised.
      const iframe = this.$refs.iframe;
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(html);
      iframe.contentWindow.document.close();
    },

    updateRemotePreview() {
      const vm = this;
      this.previewBusy = true;
      $api.post('templates/html-to-pdf', this.conversionPayload, { responseType: 'text' })
      .then(html => {
          // Our server should return sanitised HTML for preview so that we
          // don't need a client-side package (dompurify) to do this here.
          vm.dangerouslySetPreviewHtml(html);
      })
      .catch(err => {
        vm.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred while generating preview.'
        });
      })
      .finally(() => {
          this.previewBusy = false;
      });
    }
  }
};

</script>


// WEBPACK FOOTER //
// src/components/Template/TemplatePreview.vue